// Copyright 2016 Sorama B.V.

import { Unit, UnitType } from "units/Unit";

export class Time extends UnitType {
    public static override typeName = "Time";

    public static milliSecond: Unit = new Unit("ms", 1e-3, Time);
    public static second: Unit = new Unit("s", 1, Time);
    public static minute: Unit = new Unit("min", 60, Time);
    public static hour: Unit = new Unit("hour", 3600, Time, { aliases: ["h", "hr"] });
    public static day: Unit = new Unit("day", 24 * 3600, Time);
    public static year: Unit = new Unit("year", 365.25 * 24 * 3600, Time);
}
